/** Design tokens for places CSS variables cannot reach (SVG attributes, canvas, charts). Mirrors theme.css. */
export const COLORS = {
  canvas: '#f8f9fa',
  surface: '#ffffff',
  border: '#eaedf0',
  borderStrong: '#e2e8f0',
  charcoal: '#2d3139',
  charcoalMuted: '#9ca3af',
  text: '#1f2933',
  muted: '#6b7280',
  primary: '#2563eb',
  gold: '#f59e0b',
  good: '#047857',
  warn: '#b45309',
  bad: '#dc2626',
} as const;

export const PERFORMANCE_COLORS = {
  onTime: '#10b981',
  minor: '#facc15',
  moderate: '#f97316',
  major: '#dc2626',
} as const;

export const TYPOGRAPHY = {
  fontFamily: 'Inter, -apple-system, sans-serif',
  sectionHeaderPx: 15,
  tableDataPx: 13,
  subLabelPx: 11,
} as const;
